var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.toggleShowNavDrawer}},[_c('icon',{attrs:{"icon":"bars"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }